import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { NonJobEventDetailsComponent } from './non-job-event-details.component';
import { ActionSelectorComponent } from '../action-selector/action-selector.component';



@NgModule({
  declarations: [
    NonJobEventDetailsComponent,
    ActionSelectorComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    NonJobEventDetailsComponent,
    ActionSelectorComponent
  ]
})
export class NonJobEventDetailsModule { }
